import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return createStyles({
    datagrid: {
      display: 'flex',
      flexDirection: 'column',
      height: '350px',
    },
  });
});
